import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { Box } from '@mui/system';
import React, { ReactElement } from 'react';
import useSearchParams from '../../hooks/useSearchParams';

type WeeksSinceDeliveryFilterProps = {
  viewMode?: boolean;
  showAll?: boolean;
};

const options: { label: string; value: string }[] = [
  { label: 'All', value: 'all' },
  { label: '1+ weeks', value: '1' },
  { label: '2+ weeks', value: '2' },
  { label: '3+ weeks', value: '3' },
  { label: '4+ weeks', value: '4' },
  { label: '5+ weeks', value: '5' },
];

export default function WeeksSinceDeliveryFilter({ viewMode, showAll }: WeeksSinceDeliveryFilterProps): ReactElement {
  const [params, setURLParams] = useSearchParams();
  const current = options.find((option) => option.value === params.weeksSinceDelivery) ?? options[0];

  const handleChange = (event: SelectChangeEvent) => {
    setURLParams({ newParams: { weeksSinceDelivery: event.target.value === 'all' ? '' : event.target.value } });
  };

  return viewMode ? (
    <React.Fragment>
      {(params.weeksSinceDelivery || showAll) && (
        <Box component="span">
          Since last delivery: <strong>{current.label}</strong>
        </Box>
      )}
    </React.Fragment>
  ) : (
    <FormControl sx={{ minWidth: 180 }}>
      <InputLabel id="weeks-since-delivery-label" size="small" shrink>
        Since last delivery
      </InputLabel>
      <Select labelId="weeks-since-delivery-label" value={params.weeksSinceDelivery || 'all'} onChange={handleChange} label="Since last delivery" size="small">
        {options.map((item) => (
          <MenuItem key={item.label} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
